import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import fallBackImg from "../assets/nestfin/No_image_Found.png";

import { text } from "../text";
import { utils } from "../utils";
import { hooks } from "../hooks";
import { svg } from "../assets/svg";
import { theme } from "../constants";
// import { CourseType } from '../types';
import { course as elements } from "../course";
import { PropertyType } from "../types/CourseType";
import { formatIndianNumber } from "../environment";

type Props = {
  isLast?: boolean;
  course: PropertyType;
  status?: "ongoing" | "completed";
  section: "top rated" | "category list" | "my courses" | "Recommanded For you";
};

const buttonTagStyle = {
  // backgroundColor: "var(--primary-color)",
  backgroundColor: "var(--secondary-color)",
  padding: "5px 9px",
  borderRadius: "5px",
  color: "white",
  cursor: "pointer",
  fontSize: "8px",
  letterSpacing: "1px",
};
// {
//                   backgroundColor: "var(--secondary-color)",
//                   padding: "5px 10px",
//                   borderRadius: "8px",
//                   color: "white",
//                   cursor: "pointer",
//                   fontSize: "7px",
//                   letterSpacing: "1px",
//                   fontWeight: "bold",
//                 }

export const CourseCard: React.FC<Props> = ({
  course,
  section,
  isLast,
  status,
}) => {
  const navigate = hooks.useNavigate();
  // console.log(course);

  if (section === "top rated") {
    return (
      <div
        style={{
          width: "100%",
          padding: "0 20px",
          cursor: "pointer",
          userSelect: "none",
          ...utils.rowCenter(),
          marginBottom: isLast ? 0 : 10,
          paddingBottom: isLast ? 0 : 10,
          borderBottomWidth: isLast ? 0 : 1,
          borderBottomStyle: isLast ? "none" : "solid",
          borderBottomColor: `rgba(59, 89, 153, 0.1)`,
        }}
        onClick={() => {
          console.log("course", course);
          const localitySlug =
            course?.locality_name?.toLowerCase()?.replace(/\s+/g, "-") ||
            "locality";
          const citySlug =
            course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") || "city";
          const propertySlug =
            course?.property_name?.toLowerCase()?.replace(/\s+/g, "-") ||
            "property";
          const propertyId = `?id=${btoa(course?.property_id) || ""}`;

          const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;
          navigate(customUrl, { state: { course } });
        }}
      >
        <div
          style={{
            minWidth: 140,
            minHeight: 110,
            marginRight: 12,
            position: "relative",
          }}
        >
          <img
            src={course?.photos?.[0]?.photo_path || fallBackImg}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: 10,
              position: "absolute",
              inset: 0,
              objectFit: "cover",
            }}
          />
        </div>
        <div style={{ width: "100%", position: "relative" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
              zIndex: 1000,
              marginBottom: "0.4rem",
            }}
          >
            {course?.category && (
              <button style={buttonTagStyle}>
                {course?.category?.toUpperCase()}
              </button>
            )}

            {course?.gender_allowed && (
              <button style={buttonTagStyle}>
                {course?.gender_allowed?.toUpperCase()}
              </button>
            )}

            {/* {course?.is_meal_provided && ( */}
            <button style={buttonTagStyle}>
              {(!!course?.is_meal_provided &&
                course?.is_meal_provided?.toLowerCase()) == "yes"
                ? "MEAL"
                : "NO MEAL"}
            </button>
            {/* )} */}
          </div>

          <div style={{ display: "flex", marginLeft: 10 }}>
            <div>
              <p
                className="typeOfRoom"
                style={{
                  fontSize: "16px",
                  fontWeight: "500",
                  marginTop: "2px",
                }}
              >
                {course?.property_name}
              </p>
              <text.T16
                style={{
                  color: "var(--secondary-color)",
                  ...theme.fonts.Lato_700Bold,
                }}
              >
                {/* ₹{course?.minimum_rent} / month */}₹
                {formatIndianNumber(course?.minimum_rent)} / month
              </text.T16>
              <text.T16 style={{ color: "#000" }}>
                {course?.locality_name ? `${course?.locality_name}, ` : ""}
                {course?.city_name}
              </text.T16>
            </div>
          </div>

          {/* <elements.CourseInWishlist
            course={course}
            size={20}
            style={{ position: 'absolute', right: 0, top: 0 }}
          /> */}
        </div>
      </div>
    );
  }

  if (section === "category list") {
    return (
      <div
        style={{
          width: "100%",
          padding: "0 20px",
          cursor: "pointer",
          userSelect: "none",
          ...utils.rowCenter(),
          marginBottom: isLast ? 0 : 10,
          paddingBottom: isLast ? 0 : 10,
          borderBottomWidth: isLast ? 0 : 1,
          borderBottomStyle: isLast ? "none" : "solid",
          borderBottomColor: `rgba(59, 89, 153, 0.1)`,
        }}
        // onClick={() => navigate("/course-details", { state: { course } })}
        onClick={() => {
          const localitySlug =
            course?.locality_name?.toLowerCase()?.replace(/\s+/g, "-") ||
            "locality";
          const citySlug =
            course?.city_name?.toLowerCase()?.replace(/\s+/g, "-") || "city";
          const propertySlug =
            course?.property_name?.toLowerCase()?.replace(/\s+/g, "-") ||
            "property";
          const propertyId = `?id=${btoa(course?.property_id) || ""}`;

          const customUrl = `/rooms/${localitySlug}/${citySlug}/${propertySlug}/${propertyId}`;
          navigate(customUrl, { state: { course: course } });
        }}
      >
        <div
          style={{
            minWidth: 90,
            minHeight: 90,
            marginRight: 12,
            position: "relative",
          }}
        >
          <img
            src={course?.photos?.[0]?.photo_path || fallBackImg}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: 10,
              position: "absolute",
              inset: 0,
              objectFit: "cover",
            }}
          />
        </div>
        <div style={{ width: "100%", position: "relative" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "8px",
              zIndex: 1000,
            }}
          >
            {course?.category && (
              <button style={buttonTagStyle}>
                {course?.category?.toUpperCase()}
              </button>
            )}

            {course?.gender_allowed && (
              <button style={buttonTagStyle}>
                {course?.gender_allowed?.toUpperCase()}
              </button>
            )}

            {/* {course?.is_meal_provided && ( */}
            <button style={buttonTagStyle}>
              {(!!course?.is_meal_provided &&
                course?.is_meal_provided?.toLowerCase()) == "yes"
                ? "MEAL"
                : "NO MEAL"}
            </button>
            {/* )} */}
          </div>

          <div style={{ display: "flex", marginLeft: 10 }}>
            <div>
              <text.T16 style={{ color: "#000" }}>
                {course?.property_name}
              </text.T16>
              <text.T16
                style={{
                  color: "var(--secondary-color)",
                  ...theme.fonts.Lato_700Bold,
                }}
              >
                {/* ₹{course?.minimum_rent} / month */}₹
                {formatIndianNumber(course?.minimum_rent)} / month
              </text.T16>
              <text.T16 style={{ color: "#000" }}>
                {/* {course?.locality_name},    {course?.city_name}, {course?.pincode} */}
                {[course?.locality_name, course?.city_name]
                  .filter(Boolean)
                  .join(", ")}
              </text.T16>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (section === "my courses") {
    return (
      <button
        className="custom-block"
        style={{
          width: "48%",
          borderRadius: 10,
          marginBottom: 15,
        }}
      >
        <div
          style={{ height: 96, position: "relative" }}
          onClick={() => navigate("/course-details", { state: { course } })}
        >
          <img
            src={course.photos?.[0]?.photo_path}
            alt="course"
            style={{
              height: "100%",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              objectFit: "cover",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              borderTopRightRadius: 10,
              borderTopLeftRadius: 10,
            }}
          />
          <svg.PlayBtnSvg
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
        <div style={{ padding: "11px 14px 14px 14px" }}>
          <text.T14 numberOfLines={2} style={{ color: theme.colors.mainColor }}>
            {course?.property_name}
          </text.T14>
          {status === "ongoing" && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 8,
                  justifyContent: "space-between",
                }}
              >
                <text.T12
                  style={{
                    color: theme.colors.secondaryTextColor,
                    ...theme.fonts.Lato_400Regular,
                  }}
                >
                  56%
                </text.T12>
                <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
                  <svg.StarSvg />
                  <text.T10
                    style={{
                      ...theme.fonts.Lato_700Bold,
                      color: theme.colors.mainColor,
                    }}
                  >
                    {/* {course.rating} */}2
                  </text.T10>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  height: 3,
                  backgroundColor: "#C3D9FD",
                  borderRadius: 3,
                }}
              >
                <div
                  style={{
                    width: "56%",
                    height: 3,
                    backgroundColor: "#55ACEE",
                    borderRadius: 3,
                  }}
                />
              </div>
            </div>
          )}
          {status === "completed" && (
            <button
              style={{
                width: "100%",
                border: `1px solid ${theme.colors.secondaryTextColor}`,
                borderRadius: 5,
                marginTop: 6,
                padding: "4px 0px",
                ...utils.flexCenter(),
              }}
              onClick={() => navigate("/course-completed")}
              // onClick={() => navigate('/course-completed-certificate')}
            >
              <text.T10 style={{ color: theme.colors.mainColor }}>
                View certificate
              </text.T10>
            </button>
          )}
        </div>
      </button>
    );
  }

  return null;
};

// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import { text } from '../text';
// import { utils } from '../utils';
// import { hooks } from '../hooks';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// // import { CourseType } from '../types';
// import { course as elements } from '../course';
// import { PropertyType } from '../types/CourseType';

// type Props = {
//   isLast?: boolean;
//   course: PropertyType;
//   status?: 'ongoing' | 'completed';
//   section: 'top rated' | 'category list' | 'my courses' | 'Recommanded For you';
// };

// export const CourseCard: React.FC<Props> = ({
//   course,
//   section,
//   isLast,
//   status,
// }) => {
//   const navigate = hooks.useNavigate();

//   if (section === 'top rated') {
//     return (
//       <div
//         style={{
//           width: '100%',
//           padding: '0 20px',
//           cursor: 'pointer',
//           userSelect: 'none',
//           ...utils.rowCenter(),
//           marginBottom: isLast ? 0 : 10,
//           paddingBottom: isLast ? 0 : 10,
//           borderBottomWidth: isLast ? 0 : 1,
//           borderBottomStyle: isLast ? 'none' : 'solid',
//           borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//         }}
//         onClick={() => navigate('/course-details', { state: { course } })}
//       >
//         <div
//           style={{
//             minWidth: 140,
//             minHeight: 110,
//             marginRight: 12,
//             position: 'relative',
//           }}
//         >
//           <img
//             src={course.photos}
//             style={{
//               width: '100%',
//               height: '100%',
//               borderRadius: 10,
//               position: 'absolute',
//               inset: 0,
//             }}
//           />
//           {/* <elements.CourseRating
//             course={course}
//             containerStyle={{
//               margin: 2,
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//             }}
//           /> */}
//         </div>
//         <div style={{ width: '100%', position: 'relative' }}>
//           <div style={{ display: 'flex', marginLeft: 10 }}>
//             <div>
//               {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//               <p className='typeOfRoom' style={{ fontSize: "13px" }} >Semi Furnished</p>
//               <p className='typeOfRoom' style={{ fontSize: "16px", fontWeight: "500", marginTop: "7px" }} >{course?.property_name}</p>
//               <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                 ₹{course?.minimum_rent} / Month
//               </text.T16>
//               {/* <elements.CourseName
//                 course={course}
//                 numberOfLines={1}
//                 shortName={true}
//               /> */}
//               <text.T16 style={{ color: "#000" }}>
//                 {course?.city_name} {course?.pincode}
//               </text.T16>

//               {/* <elements.areaDescription
//                 course={course}
//               // numberOfLines={1}
//               // shortName={true}
//               /> */}

//             </div>
//           </div>
//           {/* <div style={{width: 202, marginRight: 30}}>
//             <text.H6
//               numberOfLines={2}
//               style={{marginBottom: 10}}
//             >
//               {course.name}
//             </text.H6>
//           </div> */}
//           {/* <div style={{...utils.rowCenter()}}>
//             <svg.ClockSvg color={theme.colors.secondaryTextColor} />
//             <text.T14
//               style={{
//                 marginLeft: 6,
//                 marginRight: 'auto',
//                 color: theme.colors.secondaryTextColor,
//               }}
//             >
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div> */}
//           <elements.CourseInWishlist
//             course={course}
//             size={20}
//             style={{ position: 'absolute', right: 0, top: 0 }}
//           />
//         </div>
//       </div>
//     );
//   }

//   if (section === 'category list') {
//     return (
//       <div
//         style={{
//           width: '100%',
//           padding: '0 20px',
//           cursor: 'pointer',
//           userSelect: 'none',
//           ...utils.rowCenter(),
//           marginBottom: isLast ? 0 : 10,
//           paddingBottom: isLast ? 0 : 10,
//           borderBottomWidth: isLast ? 0 : 1,
//           borderBottomStyle: isLast ? 'none' : 'solid',
//           borderBottomColor: `rgba(59, 89, 153, 0.1)`,
//         }}
//         onClick={() => navigate('/course-details', { state: { course } })}
//       >
//         <div
//           style={{
//             minWidth: 90,
//             minHeight: 90,
//             marginRight: 12,
//             position: 'relative',
//           }}
//         >
//           <img
//             src={course.photos}
//             style={{
//               width: '100%',
//               height: '100%',
//               borderRadius: 10,
//               position: 'absolute',
//               inset: 0,
//             }}
//           />
//           {/* <elements.CourseRating
//             course={course}
//             containerStyle={{
//               margin: 2,
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//             }}
//           /> */}
//         </div>
//         <div style={{ width: '100%', position: 'relative' }}>
//           <div style={{ display: 'flex', marginLeft: 10 }}>
//             <div>
//               {/* {course.oldPrice && (
//                 <span
//                   style={{
//                     marginRight: 6,
//                     color: theme.colors.secondaryTextColor,
//                     textDecorationLine: 'line-through',
//                     ...theme.fonts.Lato_700Bold,
//                     fontSize: 18,
//                     lineHeight: 1.5,
//                     marginTop: 3,
//                   }}
//                 >
//                   ${course.oldPrice.toFixed(2)}
//                 </span>
//               )} */}
//               <text.T16 style={{ color: "#7065F0", ...theme.fonts.Lato_700Bold, }}>
//                 ₹ 5000/Month
//               </text.T16>
//               {/* <elements.CourseName
//                 course={course}
//                 numberOfLines={1}
//                 shortName={true}
//               /> */}
//               <text.T16 style={{ color: "#000" }}>
//                 New Delhi
//               </text.T16>
//               {/* <elements.areaDescription
//                 course={course}
//               // numberOfLines={1}
//               // shortName={true}
//               /> */}
//               <elements.CourseInWishlist
//                 course={course}
//                 size={20}
//                 style={{ position: 'absolute', right: 0, top: 0 }}
//               />
//             </div>
//           </div>
//           {/* <div style={{ width: 202, marginRight: 30 }}>
//             <text.H6
//               numberOfLines={2}
//               style={{ marginBottom: 10 }}
//             >
//               {course.name}
//             </text.H6>
//           </div>
//           <div style={{ ...utils.rowCenter() }}>
//             <svg.ClockSvg />
//             <text.T14 style={{ marginLeft: 6, marginRight: 'auto' }}>
//               {course.duration}
//             </text.T14>
//             <elements.CoursePrice course={course} />
//           </div>
//          */}
//         </div>
//       </div>
//     );
//   }

//   if (section === 'my courses') {
//     return (
//       <button
//         className='custom-block'
//         style={{
//           width: '48%',
//           borderRadius: 10,
//           marginBottom: 15,
//         }}
//       >
//         <div
//           style={{ height: 96, position: 'relative' }}
//           onClick={() => navigate('/course-details', { state: { course } })}
//         >
//           <img
//             src={course.photos}
//             alt='course'
//             style={{
//               height: '100%',
//               borderTopLeftRadius: 10,
//               borderTopRightRadius: 10,
//               objectFit: 'cover',
//             }}
//           />
//           <div
//             style={{
//               position: 'absolute',
//               top: 0,
//               right: 0,
//               width: '100%',
//               height: '100%',
//               backgroundColor: 'rgba(0, 0, 0, 0.1)',
//               borderTopRightRadius: 10,
//               borderTopLeftRadius: 10,
//             }}
//           />
//           <svg.PlayBtnSvg
//             style={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)',
//             }}
//           />
//         </div>
//         <div style={{ padding: '11px 14px 14px 14px' }}>
//           <text.T14
//             numberOfLines={2}
//             style={{ color: theme.colors.mainColor }}
//           >
//             {course?.property_name}
//           </text.T14>
//           {status === 'ongoing' && (
//             <div>
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   marginTop: 8,
//                   justifyContent: 'space-between',
//                 }}
//               >
//                 <text.T12
//                   style={{
//                     color: theme.colors.secondaryTextColor,
//                     ...theme.fonts.Lato_400Regular,
//                   }}
//                 >
//                   56%
//                 </text.T12>
//                 <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
//                   <svg.StarSvg />
//                   <text.T10
//                     style={{
//                       ...theme.fonts.Lato_700Bold,
//                       color: theme.colors.mainColor,
//                     }}
//                   >
//                     {/* {course.rating} */}
//                     2
//                   </text.T10>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   width: '100%',
//                   height: 3,
//                   backgroundColor: '#C3D9FD',
//                   borderRadius: 3,
//                 }}
//               >
//                 <div
//                   style={{
//                     width: '56%',
//                     height: 3,
//                     backgroundColor: '#55ACEE',
//                     borderRadius: 3,
//                   }}
//                 />
//               </div>
//             </div>
//           )}
//           {status === 'completed' && (
//             <button
//               style={{
//                 width: '100%',
//                 border: `1px solid ${theme.colors.secondaryTextColor}`,
//                 borderRadius: 5,
//                 marginTop: 6,
//                 padding: '4px 0px',
//                 ...utils.flexCenter(),
//               }}
//               onClick={() => navigate('/course-completed')}
//             // onClick={() => navigate('/course-completed-certificate')}
//             >
//               <text.T10 style={{ color: theme.colors.mainColor }}>
//                 View certificate
//               </text.T10>
//             </button>
//           )}
//         </div>
//       </button>
//     );
//   }

//   return null;
// };
